import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth, CommonRequest, CreateRoute } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- Po Apis ------------------------------
export const getPoNumbersByVendor = createAsyncThunk(
    "getPoNumbersByVendor",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPoNumbersByVendor, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getAllPOList = createAsyncThunk(
    "getAllPOList",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllPOList, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getAdvancelicenseNumber = createAsyncThunk(
    "getAdvancelicenseNumber",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getAdvancelicenseNumber , {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const addPurchaseEntry = createAsyncThunk(
    "addPurchaseEntry",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addPurchaseEntry, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPurchaseEntrys = createAsyncThunk(
    "getPurchaseEntrys",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPurchaseEntrys, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPurchaseEntryById = createAsyncThunk(
    "getPurchaseEntryById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getPurchaseEntryById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const downloadGrn = createAsyncThunk(
    "downloadGrn",
    async (body) => {
        return CommonRequest(
            CreateRoute(BaseUrl, api.downloadGrn),
            body,
            "POST",
            {},
            { responseType: "blob", }
        )();
    }
);
export const deletePurchaseEntry = createAsyncThunk(
    "deletePurchaseEntry",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deletePurchaseEntry + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getRemainingQuantity = createAsyncThunk(
    "getRemainingQuantity",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getRemainingQuantity, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateRemainingQuantityByPONumber = createAsyncThunk(
    "updateRemainingQuantityByPONumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateRemainingQuantityByPONumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updatePurchaseEntry = createAsyncThunk(
    "updatePurchaseEntry",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updatePurchaseEntry, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

// =================== Lot Number Apis ===================
export const addLotNumber = createAsyncThunk(
    "addLotNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addLotNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getLotNumbers = createAsyncThunk(
    "getLotNumbers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getLotNumbers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getGrnAndLotNumberByPoNumber = createAsyncThunk(
    "getGrnAndLotNumberByPoNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getGrnAndLotNumberByPoNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getLotNumberById = createAsyncThunk(
    "getLotNumberById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getLotNumberById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteLotNumber = createAsyncThunk(
    "deleteLotNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deleteLotNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateLotNumber = createAsyncThunk(
    "updateLotNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateLotNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPerticularLotNumbers = createAsyncThunk(
    "getPerticularLotNumbers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPerticularLotNumbers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPOItem = createAsyncThunk(
    "getPOItem",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPOItem, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

// =================== Production Apis ===================
export const getAllProductionList = createAsyncThunk(
    "getAllProductionList",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllProductionList, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPerticularProductionAllItem = createAsyncThunk(
    "getPerticularProductionAllItem",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPerticularProductionAllItem, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteProduction = createAsyncThunk(
    "deleteProduction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deleteProduction, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const moveItemToProduction = createAsyncThunk(
    "moveItemToProduction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.moveItemToProduction, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateProduction = createAsyncThunk(
    "updateProduction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateProduction, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getItemByLotNumber = createAsyncThunk(
    "getItemByLotNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getItemByLotNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getItemForUpdateProduction = createAsyncThunk(
    "getItemForUpdateProduction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getItemForUpdateProduction, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getProductionLotNumber = createAsyncThunk(
    "getProductionLotNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getProductionLotNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getPurchaseEntryItems = createAsyncThunk(
    "getPurchaseEntryItems",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPurchaseEntryItems, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getPurchaseEntryNumber = createAsyncThunk(
    "getPurchaseEntryNumber",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getPurchaseEntryNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);